import { Component, Inject, LOCALE_ID } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DeviceDetectorService } from 'ngx-device-detector';
import { NgForm } from "@angular/forms";
import { AbstractBiditComponent } from '../abstract.bidit.component';
import { QuoteService } from '../../../quote/services/quote.service';

@Component({
  selector: 'app-materials-list-dialog',
  standalone: false,
  templateUrl: './materials-list-dialog.component.html',
  styleUrl: './materials-list-dialog.component.scss'
})
export class MaterialsListDialogComponent extends AbstractBiditComponent {
  locale: string = 'en';
  showJobAddress: boolean = false;
  showSend: boolean = false;
  branchEmail_selected: boolean = true;
  cc_selected: boolean = true;
  emailMessage: string = null;
  isRequesting: boolean = false;
  dealerId: number;

  constructor(@Inject(LOCALE_ID) locale: string,
    deviceDetectorService: DeviceDetectorService,
    public quoteService: QuoteService,
    public dialogRef: MatDialogRef<MaterialsListDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    super(deviceDetectorService);

    this.locale = locale;
  }

  printReport(): void {    
    this.dialogRef.close({ lang: this.locale, showJobAddress: this.showJobAddress });
  }

  sendEmail(showJobAddress: boolean): void {
    this.showSend = true;
    this.showJobAddress = showJobAddress;
  }

  emailMaterialsList(): void {
    let recipients: string[] = [];

    if (this.branchEmail_selected) {
      recipients.push(this.data.dealer_IDIBranchEmail);
    };

    if (this.cc_selected) {
      recipients.push(this.data.assignedToEmail);
    };

    if (!this.branchEmail_selected && !this.cc_selected) {
      alert($localize`No recipients selected`);
      return;
    }

    if (recipients.length === 0) {
      return;
    }

    this.isRequesting = true;

    this.quoteService.emailMaterialsList(this.data.quote_ID, recipients, this.emailMessage, this.showJobAddress, this.locale)
      .subscribe({
        next: (result) => {
          this.isRequesting = false;
          alert($localize`Email has been sent`);
          this.dialogRef.close(null);
          return;
        },
        error: (error: string) => this.onError(error),
        complete: () => {
          this.isRequesting = false;
          return;
        }
      });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}


